<template>
    <main class="private-area">
        <div class="nav-bar">
            <nav-bar />
        </div>
        <div class="content-area">
            <router-view />

            <apple-add-to-home-screen-modal
                v-if="showAddToHomeScreenModalForApple"
                class="apple-add-to-home-screen-modal"
                @close="closeAddToHomeScreenModalForApple(false)"
            />
        </div>
    </main>
</template>

<script>
import AppleAddToHomeScreenModal            from "@/components/AppleAddToHomeScreenModal";
import {mapState, mapActions, mapMutations} from "vuex";
import NavBar                               from "@/components/NavBar";

export default {
    name      : "PrivateLayout",
    components: {
        NavBar,
        AppleAddToHomeScreenModal
    },
    computed: {
        ...mapState("app", ["showAddToHomeScreenModalForApple"]),
        ...mapState("authentication", ["user"])
    },
    mounted() {
        if (
            window.OneSignal &&
            typeof window.OneSignal.getUserID === 'function'
        ) {
            window
                .OneSignal
                .getUserId()
                .then(
                    userID => {
                        if ( userID !== null ) {
                            this.setUserOneSignalID(userID);
                            this.updateUser(this.user);
                        }
                    }
                )
                .catch(
                    () => {
                    }
                );
        }
    },
    methods : {
        ...mapActions("app", ["closeAddToHomeScreenModalForApple"]),
        ...mapActions("authentication", ["updateUser"]),
        ...mapMutations("authentication", ["setUserOneSignalID"])
    }
};
</script>

<style lang="scss">
body {
    margin   : 0;
    overflow : hidden;
}

.private-area {
    min-height      : 100vh;
    min-width       : 100%;
    display         : flex;
    flex-direction  : column;
    flex-wrap       : nowrap;
    justify-content : center;
    align-content   : stretch;
    align-items     : center;
}

.nav-bar {
    width      : 100%;
    order      : 0;
    flex       : 0 1 auto;
    align-self : auto;
    height     : 61px;
}

.content-area {
    box-sizing : border-box;
    width      : 100%;
    padding    : 15px;
    overflow-y : auto;
    order      : 0;
    flex       : 1 1 auto;
    align-self : auto;
    max-height : calc(100vh - 61px);
}
</style>